export default "__VITE_ASSET__CtJt4F16__"